import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Contact Us</h3>
          <p>Email: <a href="mailto:ophthalmicservs@hotmail.com">ophthalmicservs@hotmail.com</a></p>
          <p>Phone: <a href="tel:4255039359">(425) 503-9359</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
